import makeStyles from "@material-ui/core/styles/makeStyles";
import colors from "Styles/colors";

const useStyles = makeStyles(({ palette } ) => ({
  button: {
    backgroundColor: palette.grey[300],
    color: colors.black,
    fontSize: 14,
    paddingTop: 0,
    paddingBottom: 0,
    minWidth: 80,
  },
}));

export default useStyles;
